
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28728",
  depVersions: {
  "payments-ui-app": "static-1.28728",
  "bend-plugin-arboretum": "static-1.2031",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.511",
  "crm_data": "static-4.93231",
  "data-fetching-client": "static-1.10126",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8769",
  "foundations-components-legacy": "static-1.1794",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6079",
  "hs-test-utils": "static-1.8526",
  "hub-http": "static-1.6693",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11974",
  "I18n": "static-7.1709",
  "jasmine-runner": "static-1.6940",
  "quartz": "static-1.7682",
  "raven": "static-3.5925",
  "react-dlb": "static-1.94",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.121",
  "react-utils": "static-2.5666",
  "reselect": "static-3.16",
  "stripe-js": "static-1.120",
  "ui-components-test-utils": "static-1.6111",
  "UIComponents": "static-3.8920",
  "usage-tracker-public": "static-1.7621",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38079",
  "payments-checkout-lib": "static-1.651",
  "cssUtils": "static-1.1110",
  "customer-data-objects": "static-1.8194",
  "FireAlarmUi": "static-1.4877",
  "foundations-assets": "static-1.5375",
  "foundations-theming": "static-1.4977",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12281",
  "icons": "static-2.704",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3371",
  "property-translator": "static-1.5867",
  "quartz-config": "static-1.1460",
  "quartz-core": "static-1.6901",
  "quartz-i18n": "static-1.1357",
  "quartz-routing": "static-1.1112",
  "quartz-tracking": "static-1.1061",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17226",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10857",
  "rpc-client-utils": "static-1.5156",
  "sanitize-text": "static-1.8645",
  "SharedI18nStrings": "static-1.188",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5246",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11632",
  "ui-images": "static-2.1278",
  "usage-tracker-core": "static-1.7660",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3959",
  "quartz-webpack": "static-1.3906",
  "bend-plugin-quartz-routing": "static-1.760",
  "bender-build-tools": "static-1.3604",
  "crm_universal": "static-1.22746",
  "customer-data-email": "static-1.18662",
  "customer-data-ui-utilities": "static-1.10319",
  "dispatcher": "static-1.148",
  "frontend-preferences-client": "static-1.8409",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8250",
  "quick-fetch": "static-1.4238",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5038",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2693",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9916",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.105",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3119",
  "ui-fonts": "static-1.1236",
  "HeadJS": "static-2.824",
  "hs-test-utils-bend-plugin": "static-1.3637",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "hs-locale-management": "static-1.409",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4793",
  "foundations-components-test-utils": "static-1.6252",
  "ui-addon-draggable": "static-3.5236",
  "commerce-billing-lib": "static-1.20518",
  "commerce-shared-components-lib": "static-1.19596",
  "commerce-tools-ui-lib": "static-1.11345",
  "crm-message-bus": "static-1.44136",
  "customer-data-objects-ui-components": "static-1.13523",
  "customer-data-properties": "static-1.53093",
  "growth-payments-core": "static-1.26526",
  "ui-addon-iframeable": "static-1.9565",
  "usage-tracker": "static-1.7810",
  "usage-tracker-container": "static-1.7800",
  "sassPrefix": "static-1.375",
  "inbound-db-properties-service-client": "static-1.4158",
  "foundations-theming-base": "static-1.3962",
  "bend-plugin-foundations-theming": "static-1.3460",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.278",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4982",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.39",
  "opentelemetry-fe": "static-1.653",
  "quartz-auth": "static-1.1357",
  "quartz-head": "static-1.1347",
  "quartz-test": "static-1.1357",
  "trellis-components": "static-1.3138",
  "usage-tracker-session-replay": "static-1.5496",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.187",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.566",
  "chirp-fetch": "static-1.2392",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4962",
  "FormUrlGenerator": "static-2.5201",
  "sequences-lib": "static-1.8808",
  "apollo-link-hub-http": "static-2.5076",
  "FileManagerCore": "static-1.40360",
  "FileManagerLib": "static-1.40501",
  "hubspot-apollo-client": "static-1.5370",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.745",
  "timezone-utils": "static-2.5718",
  "ui-gdpr-components": "static-1.10656",
  "react-dnd-compat": "static-1.5097",
  "stylex-utils": "static-1.176",
  "trellis-theming": "static-1.1501",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2974",
  "hs-resources": "static-1.672",
  "pulse": "static-1.1135",
  "utility-belt": "static-1.3025",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2036",
  "customer-data-associations": "static-1.7825",
  "customer-data-property-utils": "static-1.8539",
  "customer-data-tracking": "static-1.7359",
  "framework-data-schema-resolvers": "static-1.7380",
  "framework-data-table": "static-2.12860",
  "object-builder-ui-client": "static-1.50078",
  "payments-enrollment-embed-lib": "static-1.24240",
  "stripe-embedded-components": "static-1.8267",
  "ui-addon-opt": "static-4.8901",
  "ai-components-ui-library": "static-1.10045",
  "customer-data-rte": "static-1.33924",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24861",
  "growth-onboarding-confetti": "static-1.3545",
  "growth-onboarding-empty-states": "static-1.6554",
  "hubspot-prosemirror": "static-1.19305",
  "InboxConnectUtils": "static-4.15865",
  "payment-link-components": "static-1.24481",
  "payments-post-enroll-local-storage-lib": "static-1.5593",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39194",
  "react-colorpicker": "static-2.10697",
  "ui-addon-upgrades": "static-9.18554",
  "ui-addon-video-player": "static-1.9110",
  "user-context": "static-1.5541",
  "restore-request-side-panel-lib": "static-1.2050",
  "atom": "static-1.5559",
  "reference-resolvers": "static-1.8671",
  "calling-global-api": "static-1.66229",
  "calling-internal-common": "static-1.31812",
  "calling-lifecycle-internal": "static-1.67611",
  "calling-lifecycle-messages": "static-1.59903",
  "commerce-products-lib": "static-1.10941",
  "conditional-properties-service-client": "static-1.4120",
  "crm-index-visualization-core": "static-1.4775",
  "crm-links": "static-1.6800",
  "crm-pipelines-api-client-types": "static-1.4451",
  "customer-data-properties-shared-msw-handlers": "static-1.10252",
  "data-agent-utils": "static-1.954",
  "external-options-client-types": "static-1.4446",
  "formula-editor": "static-1.15027",
  "google-libphonenumber": "static-1.50",
  "inbound-db-meta-service-client": "static-1.3782",
  "inbounddb-objects-service-types": "static-1.4522",
  "meetings-icalendar-utils-lib": "static-1.1119",
  "multi-currency-client-types": "static-1.4015",
  "pipeline-validation-client-types": "static-1.4290",
  "property-value-citations": "static-1.3707",
  "reference-resolvers-lite": "static-1.8600",
  "smart-data-capture-core": "static-1.508",
  "smart-property-lib": "static-1.8685",
  "tiered-pricing": "static-1.2304",
  "topics-actions-lib": "static-1.671",
  "trellis-ext-i18n": "static-1.1407",
  "trial-components-library": "static-1.14403",
  "ui-addon-form-validation": "static-1.11348",
  "laboratory-lib": "static-3.7634",
  "onboarding-scopes": "static-1.6941",
  "seat-types-lib": "static-1.1070",
  "magpie-lib": "static-1.5917",
  "navigation-messaging": "static-1.8523",
  "ts-schema": "static-1.4402",
  "opentelemetry-web": "static-1.23",
  "hub-http-shared-msw-handlers": "static-1.10925",
  "hubspotter-http-shared-msw-handlers": "static-1.10923",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8665",
  "audio-components": "static-1.6591",
  "breeze-artifacts-sdk": "static-1.1025",
  "ContentUtils": "static-1.69506",
  "copilot-toolkit": "static-1.12176",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30080",
  "FileManagerImages": "static-1.38012",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4629",
  "ui-universal-auth": "static-1.9767",
  "urlinator": "static-1.5001",
  "video-components": "static-1.14469",
  "video-data-lib": "static-1.36125",
  "video-embed": "static-1.36959",
  "hubspot-apollo-cache": "static-1.829",
  "trellis-migration-context": "static-1.68",
  "event-emitter": "static-1.1449",
  "fdsr-migration-layer": "static-1.499",
  "framework-builder-read-service-client": "static-1.4342",
  "bend-plugin-pulse": "static-1.638",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7285",
  "persist-promise": "static-1.4193",
  "customer-data-reference-ui-components": "static-1.13661",
  "reporting-data": "static-1.69392",
  "tasks-actions-lib": "static-1.458",
  "purchase-motions-components": "static-1.6648",
  "growth-onboarding-feedback-components": "static-1.7068",
  "growth-onboarding-reliability": "static-1.5571",
  "marketplace-ui-apps-core": "static-1.19582",
  "onboarding-tours": "static-1.17411",
  "stripe-connect-js": "static-1.83",
  "chatspot-core": "static-1.23958",
  "content-assistance-lib": "static-1.8441",
  "draft-content-plugins": "static-1.29178",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22379",
  "rich-text-lib": "static-1.20575",
  "breeze-engine-lib": "static-1.2232",
  "poll-commands": "static-1.3965",
  "video-components-external": "static-1.12467",
  "trellis-story-utils": "static-1.4985",
  "ui-addon-react-router-dom": "static-1.10012",
  "content-media-capture": "static-1.5817",
  "knowledge-content-types": "static-1.8767",
  "ui-addon-emoji-picker": "static-1.10350",
  "ui-business-units-lib": "static-1.9584",
  "ui-shepherd-react": "static-3.10767",
  "hub-http-contrib": "static-1.3520",
  "ui-addon-sales-email": "static-1.5689",
  "commerce-tours-lib": "static-1.6880",
  "getting-started-shared-tasks": "static-1.19588",
  "sales-checkout-service-client": "static-1.4008",
  "merchandise-lib": "static-1.286",
  "getting-started-shared-tasks-store": "static-1.18706",
  "onboarding-tours-utils": "static-1.1478",
  "calling-error-reporting": "static-1.31819",
  "shared-worker-versioning": "static-1.11531",
  "calling-usage-tracker": "static-1.7028",
  "conversations-skeleton-state": "static-1.7609",
  "voice-sms-access-library": "static-1.2491",
  "commerce-permissions": "static-1.1273",
  "products-iframe-lib": "static-1.8940",
  "products-ui-components-shared-msw-handlers": "static-1.11307",
  "crm-index-associations-lib": "static-1.6935",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11008",
  "sales-views-client-types": "static-1.4746",
  "location-customization-utils-lib": "static-1.10445",
  "data-agent-kit": "static-1.941",
  "enrichment-settings-lib": "static-1.257",
  "fsm": "static-1.4245",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7291",
  "bark-lib": "static-1.17021",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6384",
  "react-codemirror": "static-1.11129",
  "data-agent-test-utils": "static-1.485",
  "data-token-picker": "static-1.17155",
  "react-tinymce": "static-1.56290",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11071",
  "tinymce-config": "static-2.55416",
  "tinymce-plugins": "static-1.58530",
  "embedded-academy-lib": "static-1.16042",
  "hubs-service-types": "static-1.1755",
  "navigation-components": "static-1.19196",
  "nest": "static-1.723",
  "nudge-client-utils": "static-1.3443",
  "purchase-motions-api": "static-1.6651",
  "signup-constants": "static-1.19969",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5377",
  "reactive-lib": "static-1.1208",
  "simple-logging-lib": "static-1.3538",
  "nav-meta": "static-1.30833",
  "breeze-engine-core": "static-1.1510",
  "cms-field-types": "static-1.5297",
  "content-icons-ui": "static-1.2469",
  "integrations-lib": "static-1.17458",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.331",
  "unified-auth-core-lib": "static-1.1563",
  "social-insights-client-types": "static-1.22953",
  "outpost": "static-1.4616",
  "reporting-client-types": "static-1.2847",
  "signup-ui-url-generator": "static-2.8525",
  "developer-experience-shared-components": "static-1.11028",
  "immutable-less": "static-1.5139",
  "marketplace-ui-client-types": "static-1.18457",
  "marketplace-ui-common": "static-1.21050",
  "ui-addon-integrations-directory-panel": "static-2.8441",
  "ui-extensibility-client-types": "static-1.4402",
  "growth-data-modal": "static-1.6154",
  "growth-onboarding-next-action-utils": "static-1.3009",
  "onboarding-tours-client": "static-1.5626",
  "ui-shepherd-tracker": "static-1.8148",
  "ui-coaching-tips": "static-1.29596",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1210",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "media-bridge-lib": "static-1.19661",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4916",
  "calling-orchestration-schema": "static-1.37268",
  "crm-record-cards-service-types": "static-1.3871",
  "highcharts": "static-8.115",
  "storybook-react": "static-1.44",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16691",
  "browser-eslint": "static-2.57",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57386",
  "interframe": "static-3.5229",
  "tinymce-data": "static-1.41501",
  "layout-dnd-components": "static-1.13247",
  "layout-dnd-utils": "static-1.12222",
  "ui-brand-identity-lib": "static-1.16981",
  "academy-common-lib": "static-1.15503",
  "nudge-custom-function-registry": "static-1.3200",
  "nudge-renderer-utils": "static-1.3519",
  "whisper-core-api": "static-1.7662",
  "flux-actions": "static-1.381",
  "integrations-error-boundary-lib": "static-1.14873",
  "integrations-tracking-lib": "static-1.6110",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4624",
  "ai-settings-ui-library": "static-1.8614",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1613",
  "onboarding-data-sync-lib": "static-1.2858",
  "growth-onboarding-next-action-components": "static-1.3037",
  "user-context-client": "static-1.4997",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9375",
  "ContentData": "static-1.69581",
  "layout-data-lib": "static-1.10547",
  "academy-service-client": "static-1.4179",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4884",
  "trellis-ecosystem": "static-1.7870",
  "wootric-nps": "static-1.7305",
  "universal-page-editor-lib": "static-1.3500",
  "settings-ui-lib": "static-1.13015",
  "simple-data-table": "static-1.3846",
  "meetings-connect-utils-lib": "static-1.8107",
  "advanced-menus-core": "static-1.15837",
  "advanced-menus-lib": "static-1.12584",
  "ExportDialog": "static-6.10860",
  "ui-memberships-settings-lib": "static-1.35226",
  "crm-record-cards-client": "static-1.84",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15836",
  "simple-menus-lib": "static-1.17353"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28728",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2031",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.511",
  "crm_data": "/crm_data/static-4.93231",
  "data-fetching-client": "/data-fetching-client/static-1.10126",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8769",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1794",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6079",
  "hs-test-utils": "/hs-test-utils/static-1.8526",
  "hub-http": "/hub-http/static-1.6693",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11974",
  "I18n": "/I18n/static-7.1709",
  "jasmine-runner": "/jasmine-runner/static-1.6940",
  "quartz": "/quartz/static-1.7682",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.94",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.121",
  "react-utils": "/react-utils/static-2.5666",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.120",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6111",
  "UIComponents": "/UIComponents/static-3.8920",
  "usage-tracker-public": "/usage-tracker-public/static-1.7621",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38079",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.651",
  "cssUtils": "/cssUtils/static-1.1110",
  "customer-data-objects": "/customer-data-objects/static-1.8194",
  "FireAlarmUi": "/FireAlarmUi/static-1.4877",
  "foundations-assets": "/foundations-assets/static-1.5375",
  "foundations-theming": "/foundations-theming/static-1.4977",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12281",
  "icons": "/icons/static-2.704",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3371",
  "property-translator": "/property-translator/static-1.5867",
  "quartz-config": "/quartz-config/static-1.1460",
  "quartz-core": "/quartz-core/static-1.6901",
  "quartz-i18n": "/quartz-i18n/static-1.1357",
  "quartz-routing": "/quartz-routing/static-1.1112",
  "quartz-tracking": "/quartz-tracking/static-1.1061",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17226",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10857",
  "rpc-client-utils": "/rpc-client-utils/static-1.5156",
  "sanitize-text": "/sanitize-text/static-1.8645",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5246",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11632",
  "ui-images": "/ui-images/static-2.1278",
  "usage-tracker-core": "/usage-tracker-core/static-1.7660",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3959",
  "quartz-webpack": "/quartz-webpack/static-1.3906",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.760",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "crm_universal": "/crm_universal/static-1.22746",
  "customer-data-email": "/customer-data-email/static-1.18662",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10319",
  "dispatcher": "/dispatcher/static-1.148",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8409",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8250",
  "quick-fetch": "/quick-fetch/static-1.4238",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5038",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2693",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9916",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3119",
  "ui-fonts": "/ui-fonts/static-1.1236",
  "HeadJS": "/HeadJS/static-2.824",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3637",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "hs-locale-management": "/hs-locale-management/static-1.409",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4793",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6252",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5236",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20518",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19596",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11345",
  "crm-message-bus": "/crm-message-bus/static-1.44136",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13523",
  "customer-data-properties": "/customer-data-properties/static-1.53093",
  "growth-payments-core": "/growth-payments-core/static-1.26526",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9565",
  "usage-tracker": "/usage-tracker/static-1.7810",
  "usage-tracker-container": "/usage-tracker-container/static-1.7800",
  "sassPrefix": "/sassPrefix/static-1.375",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4158",
  "foundations-theming-base": "/foundations-theming-base/static-1.3962",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3460",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.278",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4982",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.39",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.653",
  "quartz-auth": "/quartz-auth/static-1.1357",
  "quartz-head": "/quartz-head/static-1.1347",
  "quartz-test": "/quartz-test/static-1.1357",
  "trellis-components": "/trellis-components/static-1.3138",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5496",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.187",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.566",
  "chirp-fetch": "/chirp-fetch/static-1.2392",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4962",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5201",
  "sequences-lib": "/sequences-lib/static-1.8808",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5076",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5370",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.745",
  "timezone-utils": "/timezone-utils/static-2.5718",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "react-dnd-compat": "/react-dnd-compat/static-1.5097",
  "stylex-utils": "/stylex-utils/static-1.176",
  "trellis-theming": "/trellis-theming/static-1.1501",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2974",
  "hs-resources": "/hs-resources/static-1.672",
  "pulse": "/pulse/static-1.1135",
  "utility-belt": "/utility-belt/static-1.3025",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2036",
  "customer-data-associations": "/customer-data-associations/static-1.7825",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8539",
  "customer-data-tracking": "/customer-data-tracking/static-1.7359",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7380",
  "framework-data-table": "/framework-data-table/static-2.12860",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50078",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24240",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8267",
  "ui-addon-opt": "/ui-addon-opt/static-4.8901",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10045",
  "customer-data-rte": "/customer-data-rte/static-1.33924",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3545",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6554",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19305",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15865",
  "payment-link-components": "/payment-link-components/static-1.24481",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5593",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39194",
  "react-colorpicker": "/react-colorpicker/static-2.10697",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18554",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9110",
  "user-context": "/user-context/static-1.5541",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2050",
  "atom": "/atom/static-1.5559",
  "reference-resolvers": "/reference-resolvers/static-1.8671",
  "calling-global-api": "/calling-global-api/static-1.66229",
  "calling-internal-common": "/calling-internal-common/static-1.31812",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67611",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59903",
  "commerce-products-lib": "/commerce-products-lib/static-1.10941",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4120",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4775",
  "crm-links": "/crm-links/static-1.6800",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4451",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10252",
  "data-agent-utils": "/data-agent-utils/static-1.954",
  "external-options-client-types": "/external-options-client-types/static-1.4446",
  "formula-editor": "/formula-editor/static-1.15027",
  "google-libphonenumber": "/google-libphonenumber/static-1.50",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3782",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4522",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1119",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4015",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4290",
  "property-value-citations": "/property-value-citations/static-1.3707",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8600",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.508",
  "smart-property-lib": "/smart-property-lib/static-1.8685",
  "tiered-pricing": "/tiered-pricing/static-1.2304",
  "topics-actions-lib": "/topics-actions-lib/static-1.671",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1407",
  "trial-components-library": "/trial-components-library/static-1.14403",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "laboratory-lib": "/laboratory-lib/static-3.7634",
  "onboarding-scopes": "/onboarding-scopes/static-1.6941",
  "seat-types-lib": "/seat-types-lib/static-1.1070",
  "magpie-lib": "/magpie-lib/static-1.5917",
  "navigation-messaging": "/navigation-messaging/static-1.8523",
  "ts-schema": "/ts-schema/static-1.4402",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10925",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10923",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8665",
  "audio-components": "/audio-components/static-1.6591",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1025",
  "ContentUtils": "/ContentUtils/static-1.69506",
  "copilot-toolkit": "/copilot-toolkit/static-1.12176",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30080",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4629",
  "ui-universal-auth": "/ui-universal-auth/static-1.9767",
  "urlinator": "/urlinator/static-1.5001",
  "video-components": "/video-components/static-1.14469",
  "video-data-lib": "/video-data-lib/static-1.36125",
  "video-embed": "/video-embed/static-1.36959",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.829",
  "trellis-migration-context": "/trellis-migration-context/static-1.68",
  "event-emitter": "/event-emitter/static-1.1449",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.499",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4342",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.638",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7285",
  "persist-promise": "/persist-promise/static-1.4193",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13661",
  "reporting-data": "/reporting-data/static-1.69392",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.458",
  "purchase-motions-components": "/purchase-motions-components/static-1.6648",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7068",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5571",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "stripe-connect-js": "/stripe-connect-js/static-1.83",
  "chatspot-core": "/chatspot-core/static-1.23958",
  "content-assistance-lib": "/content-assistance-lib/static-1.8441",
  "draft-content-plugins": "/draft-content-plugins/static-1.29178",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22379",
  "rich-text-lib": "/rich-text-lib/static-1.20575",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2232",
  "poll-commands": "/poll-commands/static-1.3965",
  "video-components-external": "/video-components-external/static-1.12467",
  "trellis-story-utils": "/trellis-story-utils/static-1.4985",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10012",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10350",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9584",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10767",
  "hub-http-contrib": "/hub-http-contrib/static-1.3520",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5689",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6880",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19588",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4008",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18706",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "calling-error-reporting": "/calling-error-reporting/static-1.31819",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11531",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7028",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7609",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2491",
  "commerce-permissions": "/commerce-permissions/static-1.1273",
  "products-iframe-lib": "/products-iframe-lib/static-1.8940",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11307",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6935",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11008",
  "sales-views-client-types": "/sales-views-client-types/static-1.4746",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10445",
  "data-agent-kit": "/data-agent-kit/static-1.941",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.257",
  "fsm": "/fsm/static-1.4245",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7291",
  "bark-lib": "/bark-lib/static-1.17021",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6384",
  "react-codemirror": "/react-codemirror/static-1.11129",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.485",
  "data-token-picker": "/data-token-picker/static-1.17155",
  "react-tinymce": "/react-tinymce/static-1.56290",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11071",
  "tinymce-config": "/tinymce-config/static-2.55416",
  "tinymce-plugins": "/tinymce-plugins/static-1.58530",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16042",
  "hubs-service-types": "/hubs-service-types/static-1.1755",
  "navigation-components": "/navigation-components/static-1.19196",
  "nest": "/nest/static-1.723",
  "nudge-client-utils": "/nudge-client-utils/static-1.3443",
  "purchase-motions-api": "/purchase-motions-api/static-1.6651",
  "signup-constants": "/signup-constants/static-1.19969",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5377",
  "reactive-lib": "/reactive-lib/static-1.1208",
  "simple-logging-lib": "/simple-logging-lib/static-1.3538",
  "nav-meta": "/nav-meta/static-1.30833",
  "breeze-engine-core": "/breeze-engine-core/static-1.1510",
  "cms-field-types": "/cms-field-types/static-1.5297",
  "content-icons-ui": "/content-icons-ui/static-1.2469",
  "integrations-lib": "/integrations-lib/static-1.17458",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.331",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1563",
  "social-insights-client-types": "/social-insights-client-types/static-1.22953",
  "outpost": "/outpost/static-1.4616",
  "reporting-client-types": "/reporting-client-types/static-1.2847",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8525",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11028",
  "immutable-less": "/immutable-less/static-1.5139",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8441",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4402",
  "growth-data-modal": "/growth-data-modal/static-1.6154",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3009",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8148",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29596",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1210",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "media-bridge-lib": "/media-bridge-lib/static-1.19661",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4916",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37268",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "highcharts": "/highcharts/static-8.115",
  "storybook-react": "/storybook-react/static-1.44",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16691",
  "browser-eslint": "/browser-eslint/static-2.57",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57386",
  "interframe": "/interframe/static-3.5229",
  "tinymce-data": "/tinymce-data/static-1.41501",
  "layout-dnd-components": "/layout-dnd-components/static-1.13247",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12222",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16981",
  "academy-common-lib": "/academy-common-lib/static-1.15503",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3200",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3519",
  "whisper-core-api": "/whisper-core-api/static-1.7662",
  "flux-actions": "/flux-actions/static-1.381",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14873",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6110",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4624",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8614",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1613",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2858",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3037",
  "user-context-client": "/user-context-client/static-1.4997",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9375",
  "ContentData": "/ContentData/static-1.69581",
  "layout-data-lib": "/layout-data-lib/static-1.10547",
  "academy-service-client": "/academy-service-client/static-1.4179",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4884",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7870",
  "wootric-nps": "/wootric-nps/static-1.7305",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3500",
  "settings-ui-lib": "/settings-ui-lib/static-1.13015",
  "simple-data-table": "/simple-data-table/static-1.3846",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8107",
  "advanced-menus-core": "/advanced-menus-core/static-1.15837",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12584",
  "ExportDialog": "/ExportDialog/static-6.10860",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35226",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.84",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15836",
  "simple-menus-lib": "/simple-menus-lib/static-1.17353"
}
};
